import { Routes, Route, Navigate } from 'react-router-dom';
import Layout from './components/Layout';
import HomePage from './pages/HomePage';
import AboutPage from './pages/AboutPage';
import ContactPage from './pages/ContactPage';
import GalleryPage from './pages/GalleryPage';
import ServicePage from './pages/services/ServicePage';
import ProductPage from './pages/products/ProductPage';
import NotFoundPage from './pages/NotFoundPage';
import { servicesData } from './data/servicesData';
import { productsData } from './data/productsData';
import PortfolioPage from './pages/portfolio/PortfolioPage';
import { portfolioData } from './data/portfolioData';
import InquiryListPage from './pages/InquiryListPage';

function App() {
  return (
    <>
      <Routes>
        {/* Wrap each route with Layout */}
        <Route path="/" element={
          <Layout>
            <HomePage />
          </Layout>
        } />

        <Route path="/about" element={
          <Layout>
            <AboutPage />
          </Layout>
        } />

        <Route path="/contact" element={
          <Layout>
            <ContactPage />
          </Layout>
        } />

        <Route path="/gallery" element={
          <Layout>
            <GalleryPage />
          </Layout>
        } />

        {/* Dynamic Service Routes */}
        {Object.keys(servicesData).map(slug => (
          <Route
            key={`service-${slug}`}
            path={`/services/${slug}`}
            element={
              <Layout>
                <ServicePage slug={slug} />
              </Layout>
            }
          />
        ))}

        {/* Dynamic Product Routes */}
        {Object.keys(productsData).map(slug => (
          <Route
            key={`product-${slug}`}
            path={`/products/${slug}`}
            element={
              <Layout>
                <ProductPage slug={slug} />
              </Layout>
            }
          />
        ))}

        {/* Dynamic Portfolio Routes */}
        {Object.keys(portfolioData).map(slug => (
          <Route
            key={`portfolio-${slug}`}
            path={`/portfolio/${slug}`}
            element={
              <Layout>
                <PortfolioPage slug={slug} />
              </Layout>
            }
          />
        ))}

        {/* Inquiry List Route */}
        <Route path="/inquiry-list" element={
          <Layout>
            <InquiryListPage />
          </Layout>
        } />

        {/* 404 Handler */}
        <Route path="/404" element={
          <Layout>
            <NotFoundPage />
          </Layout>
        } />
        <Route path="*" element={<Navigate to="/404" replace />} />
      </Routes>
    </>
  );
}

export default App;
